import { BaseModel } from '@/app/modules/base/BaseModel';

export type ConstructorProps<T> = T extends {
    new(...args: infer U): any
  }
  ? U
  : never

export type ConstructorResult<T> = T extends {
    new(...args: any): infer U
  }
  ? U
  : never

export function instance<T extends { new(...args: any[]): any }>(
  constructorFunction: T,
  ...args: ConstructorProps<T>
): ConstructorResult<T> {
  // eslint-disable-next-line new-cap
  return new constructorFunction(...args);
}

type applierFn<T extends any> = (model: any, ...args: any) => Promise<T> | T
const appliers = new Map();

/**
 * @deprecated legacy
 */
export function createApplier<U extends any>(id: any) {
  return <T = undefined>(model: BaseModel, ...args: any): Promise<T extends undefined ? U : T> => {
    const applier = appliers.get(id);

    if (!applier) {
      throw new Error(`No applier for model ${model.constructor.name}`);
    }

    const result = applier(model, ...args);

    if (!(result instanceof Promise)) {
      return Promise.resolve(result);
    }

    return result;
  };
}

/**
 * @deprecated legacy
 */
export function registerApplier(id: any, applier: applierFn<any>) {
  appliers.set(id, applier);
}

/**
 * @deprecated legacy
 */
export const defineModelFactory = <T, >() => <D extends Partial<T>>(defaults?: D) => {
  return (
    required?: Omit<T, keyof D> & Partial<D>,
    changed?: Partial<T>,
  ): Readonly<T> => {
    return Object.freeze({
      ...defaults,
      ...required,
      ...changed,
    } as T);
  };
};

/**
 * @deprecated legacy
 */
export const defineModelEffect = <T extends (...args: any[]) => any, R extends any>(modelFactory: T, fn: (model: ReturnType<T>) => R) => {
  return <CR = void>(...args: Parameters<T>): Readonly<CR extends void ? R : CR> => {
    const model = modelFactory(...args);
    return fn(model) as CR extends void ? R : CR;
  };
};
